import {isIP} from 'is-ip';
import {formatDisconnectTimeout} from '../utility.js';

export default (initialData) => ({
    apiKey: initialData.apiKey || '',
    vncPassword: initialData.vncPassword || '',
    ipAddresses: initialData.ipAddresses || ['', '', ''],
    vncAccess: initialData.vncAccess || 'password',
    browserWebsocketAccess: initialData.browserWebsocketAccess || 'ip',
    disconnectTimeoutSeconds: initialData.disconnectTimeoutSeconds || 60,
    copied: false,
    showPassword: false,
    saving: false,
    regenerating: false,
    reloadingSettings: false,
    ipValidationTimeout: null,

    resetInviteForm() {
        this.$refs.inviteForm?.reset();
    },

    async reloadSettings() {
        if (this.reloadingSettings) return;

        if (this.$ajax) {
            this.reloadingSettings = true;
            try {
                await this.$ajax('/settings', {
                    target: 'main',
                    sync: false,
                    focus: false,
                });
            } finally {
                this.reloadingSettings = false;
            }
        } else {
            this.$refs.settingsReloadLink?.click();
        }
    },

    async onInviteSuccess() {
        this.resetInviteForm();
        await this.reloadSettings();
    },

    validateIP(index) {
        clearTimeout(this.ipValidationTimeout);
        this.ipValidationTimeout = setTimeout(() => {
            const ip = this.ipAddresses[index];
            const errorEl = document.getElementById(`ipAddress${index + 1}-error`);

            if (!errorEl) return;

            if (ip && !isIP(ip)) {
                errorEl.textContent = 'IP Address ' + (index + 1) + ' is not valid IP';
                errorEl.className = 'error-message';
            } else {
                errorEl.textContent = '';
                errorEl.className = '';
            }
        }, 500);
    },

    validateVncPassword() {
        const errorEl = document.getElementById('vncPassword-error');
        if (!errorEl) return;

        const password = this.vncPassword;
        const alphanumericRegex = /^[a-zA-Z0-9]+$/;

        if (password && password.length > 0) {
            if (password.length < 5) {
                errorEl.textContent = 'VNC Password must be at least 5 characters';
                errorEl.className = 'error-message';
                return;
            }
            if (password.length > 30) {
                errorEl.textContent = 'VNC Password must not exceed 30 characters';
                errorEl.className = 'error-message';
                return;
            }
            if (!alphanumericRegex.test(password)) {
                errorEl.textContent = 'VNC Password must contain only alphanumeric characters (a-z, A-Z, 0-9)';
                errorEl.className = 'error-message';
                return;
            }
        }

        errorEl.textContent = '';
        errorEl.className = '';
    },

    formatDisconnectTimeout,

    async confirmRemoveMember(userId, name) {
        const confirmed = await Alpine.store('confirmModal').open(
            'Remove team member',
            `Are you sure you want to remove ${name} from the team?`,
            { confirmText: 'Remove', confirmClass: 'btn-error' }
        );

        if (!confirmed) return;

        await this.$ajax(`/settings/account/member/${userId}/remove`, {
            method: 'POST',
            target: '_none',
        });

        await this.reloadSettings();
    },

    async regenerateApiKey() {
        const confirmed = await Alpine.store('confirmModal').open(
            'Regenerate API Key',
            'Are you sure? This will invalidate the current key.'
        );

        if (!confirmed) return;

        this.regenerating = true;

        try {
            const response = await fetch('/settings/regenerate-api-key', {
                method: 'POST'
            });

            if (!response.ok) {
                throw new Error('Failed to regenerate API key');
            }

            const data = await response.json();
            if (data.success) {
                this.apiKey = data.apiKey;
            }
        } catch (error) {
            console.error('Error regenerating API key:', error);
        } finally {
            this.regenerating = false;
        }
    }
})
